import React from 'react';
// import Avatar from '../avatar/Avatar';
import SkillsMenue from './SkillsMenu';

export default function Skills() {
  return (
    <>
      {/* <Avatar page="skills" /> */}
      <SkillsMenue />
    </>

  );
}
